/**
 * Helper functions for PII Scanner
 */

/**
 * Format category colors for PII types
 */
export const getCategoryColors = () => {
  return {
    Name: {
      bg: "bg-purple-50",
      text: "text-purple-700",
      border: "border-purple-200",
    },
    Email: {
      bg: "bg-blue-50",
      text: "text-blue-700",
      border: "border-blue-200",
    },
    Phone: {
      bg: "bg-green-50",
      text: "text-green-700",
      border: "border-green-200",
    },
    CreditCard: {
      bg: "bg-red-50",
      text: "text-red-700",
      border: "border-red-200",
    },
    Address: {
      bg: "bg-orange-50",
      text: "text-orange-700",
      border: "border-orange-200",
    },
    IBAN: {
      bg: "bg-pink-50",
      text: "text-pink-700",
      border: "border-pink-200",
    },
    SSN: {
      bg: "bg-yellow-50",
      text: "text-yellow-700",
      border: "border-yellow-200",
    },
  };
};

/**
 * Get category style by category name
 */
export const getCategoryStyle = (category) => {
  const colors = getCategoryColors();
  return (
    colors[category] || {
      bg: "bg-gray-50",
      text: "text-gray-700",
      border: "border-gray-200",
    }
  );
};

/**
 * Handle keyboard events on interactive elements
 */
export const handleKeyDown = (evt, callback) => {
  if (evt.key === "Enter" || evt.key === " ") {
    evt.preventDefault();
    callback();
  }
};

/**
 * Export scan results to CSV
 */
export const exportScanResultsToCSV = (scanResults, samplePiiData) => {
  const rows = [
    [
      "Table",
      "Column",
      "PII Categories",
      "Compliance",
      "Risk",
      "Confidence",
      "Sample Values",
    ],
  ];

  samplePiiData.forEach((table) => {
    table.pii_columns.forEach((col) => {
      rows.push([
        `${table.schema}.${table.table_name}`,
        col.column_name,
        col.pii_categories.join(", "),
        col.compliance.join(", "),
        col.risk,
        col.confidence,
        col.samples.join(" | "),
      ]);
    });
  });

  const csv = rows.map((r) => r.map((c) => `"${c}"`).join(",")).join("\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "pii_details.csv";
  a.click();
};

/**
 * Process single table scan results
 */
export const processScanResults = (scanResults) => {
  const samplePiiData = scanResults.results
    ?.filter((result) => result.pii_columns && result.pii_columns.length > 0)
    .map((result) => ({
      table_name: result.table_name,
      schema: result.schema || "dbo",
      row_count: result.row_count,
      pii_columns: result.pii_columns.map((col) => ({
        column_name: col.column_name,
        pii_categories: (col.pii_types || []).map((t) => t.replaceAll("_", " ")),
        compliance: col.compliance || [],
        risk: (col.risk || "LOW").toUpperCase(),
        confidence: col.confidence || "—",
        samples: col.samples || [],
      })),
    })) || [];

  return samplePiiData;
};

/**
 * Extract table names from tables array
 */
export const getTableNames = (tables) => {
  return tables.map((table) =>
    typeof table === "string" ? table : table.name || table.table_name,
  );
};
